// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ecl-input-container,
.ecl-input-container-combo {
   width: 100%;
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   align-items: center;
   border: var(--border);
   border-radius: var(--border-radius);
   background-color: var(--frame-bg);
   padding: 0px 5px;
}

.ecl-input-container input {
   margin: unset;
}

.ecl-input-container input,
.ecl-input-container-combo input {
   background-color: unset;
   padding: 5px 0px;
}

.unit-of-measurement {
   height: 100%;
   padding: 0px 10px;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
   background-color: none;
   border-radius: var(--border-radius);
}

.ecl-input-container>.ecl-input,
.ecl-float-input,
.ecl-input-container-combo>.ecl-input,
.ecl-input-container-combo select {
   border: none;
}

.ecl-input-container-combo select {
   background-color: unset;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
}

/* Hover Styling */

.ecl-input-container:hover,
.ecl-input-container-combo:hover {
   background-color: var(--frame-bg-hovered);
}

.ecl-input-container input:hover,
.ecl-input-container-combo input:hover {
   background-color: unset;
}

.ecl-input-container-combo select:hover {
   background-color: unset;
}

/* Focus Visible */
.ecl-input-container:has(input:focus-visible),
.ecl-input-container-combo:has(input:focus-visible) {
   outline: var(--outline-focus-visible)
}

.ecl-input-container input:focus-visible,
.ecl-input-container-combo input:focus-visible {
   outline: none
}

/* Invalid Styling */

.ecl-input-container input:invalid,
.ecl-input-container-combo input:invalid {
   outline: none
}

.ecl-input-container:has(input:invalid),
.ecl-input-container-combo:has(input:invalid) {
   outline: none;
}

.ecl-input-container:has(input:invalid:not(:placeholder-shown)),
.ecl-input-container-combo:has(input:invalid:not(:placeholder-shown)) {
   outline: 2px solid var(--required);
}

`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLBlockument/Blocks/ECLObjectBlock/Inputs/ECLInput.css"],"names":[],"mappings":"AAAA;;GAEG,WAAW;GACX,aAAa;GACb,mBAAmB;GACnB,8BAA8B;GAC9B,mBAAmB;GACnB,qBAAqB;GACrB,mCAAmC;GACnC,iCAAiC;GACjC,gBAAgB;AACnB;;AAEA;GACG,aAAa;AAChB;;AAEA;;GAEG,uBAAuB;GACvB,gBAAgB;AACnB;;AAEA;GACG,YAAY;GACZ,iBAAiB;GACjB,gBAAgB;GAChB,mBAAmB;GACnB,uBAAuB;GACvB,sBAAsB;GACtB,mCAAmC;AACtC;;AAEA;;;;GAIG,YAAY;AACf;;AAEA;GACG,uBAAuB;GACvB,gBAAgB;GAChB,mBAAmB;GACnB,uBAAuB;AAC1B;;AAEA,kBAAkB;;AAElB;;GAEG,yCAAyC;AAC5C;;AAEA;;GAEG,uBAAuB;AAC1B;;AAEA;GACG,uBAAuB;AAC1B;;AAEA,kBAAkB;AAClB;;GAEG;AACH;;AAEA;;GAEG;AACH;;AAEA,oBAAoB;;AAEpB;;GAEG;AACH;;AAEA;;GAEG,aAAa;AAChB;;AAEA;;GAEG,kCAAkC;AACrC","sourcesContent":[".ecl-input-container,\r\n.ecl-input-container-combo {\r\n   width: 100%;\r\n   display: flex;\r\n   flex-direction: row;\r\n   justify-content: space-between;\r\n   align-items: center;\r\n   border: var(--border);\r\n   border-radius: var(--border-radius);\r\n   background-color: var(--frame-bg);\r\n   padding: 0px 5px;\r\n}\r\n\r\n.ecl-input-container input {\r\n   margin: unset;\r\n}\r\n\r\n.ecl-input-container input,\r\n.ecl-input-container-combo input {\r\n   background-color: unset;\r\n   padding: 5px 0px;\r\n}\r\n\r\n.unit-of-measurement {\r\n   height: 100%;\r\n   padding: 0px 10px;\r\n   overflow: hidden;\r\n   white-space: nowrap;\r\n   text-overflow: ellipsis;\r\n   background-color: none;\r\n   border-radius: var(--border-radius);\r\n}\r\n\r\n.ecl-input-container>.ecl-input,\r\n.ecl-float-input,\r\n.ecl-input-container-combo>.ecl-input,\r\n.ecl-input-container-combo select {\r\n   border: none;\r\n}\r\n\r\n.ecl-input-container-combo select {\r\n   background-color: unset;\r\n   overflow: hidden;\r\n   white-space: nowrap;\r\n   text-overflow: ellipsis;\r\n}\r\n\r\n/* Hover Styling */\r\n\r\n.ecl-input-container:hover,\r\n.ecl-input-container-combo:hover {\r\n   background-color: var(--frame-bg-hovered);\r\n}\r\n\r\n.ecl-input-container input:hover,\r\n.ecl-input-container-combo input:hover {\r\n   background-color: unset;\r\n}\r\n\r\n.ecl-input-container-combo select:hover {\r\n   background-color: unset;\r\n}\r\n\r\n/* Focus Visible */\r\n.ecl-input-container:has(input:focus-visible),\r\n.ecl-input-container-combo:has(input:focus-visible) {\r\n   outline: var(--outline-focus-visible)\r\n}\r\n\r\n.ecl-input-container input:focus-visible,\r\n.ecl-input-container-combo input:focus-visible {\r\n   outline: none\r\n}\r\n\r\n/* Invalid Styling */\r\n\r\n.ecl-input-container input:invalid,\r\n.ecl-input-container-combo input:invalid {\r\n   outline: none\r\n}\r\n\r\n.ecl-input-container:has(input:invalid),\r\n.ecl-input-container-combo:has(input:invalid) {\r\n   outline: none;\r\n}\r\n\r\n.ecl-input-container:has(input:invalid:not(:placeholder-shown)),\r\n.ecl-input-container-combo:has(input:invalid:not(:placeholder-shown)) {\r\n   outline: 2px solid var(--required);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
